import { api, bearer } from './client';
import type { CatalogueWrite } from '../staff/catalogue';
import type { WriteOutcome } from '../staff/publishPackaging';

// Reads `reason` (400/409/412) and `version` (503) as runtime fields — the server sends them
// (CatalogueWriteEndpoint.cs) though the typed ErrorResponse omits them. 503 with no version
// => unaudited with undefined version; the caller reloads rather than retrying blind. Any HTTP
// response maps to an outcome; a failed fetch (openapi-fetch throws — network down, CORS
// preflight refused, DNS) is caught and mapped to `unreachable`, so this never rejects and the
// publish reports every row instead of dying with an unhandled rejection.
export function makePut(token: string): (w: CatalogueWrite) => Promise<WriteOutcome> {
  return async (write) => {
    try {
      const { data, error, response } = await api.PUT('/admin/catalogue/{productId}/{itemId}', {
        params: { path: { productId: write.productId, itemId: write.id }, header: write.version == null ? {} : { 'If-Match': String(write.version) } },
        body: write.body,
        headers: bearer(token),
      });
      const status = response?.status ?? 0;
      if (!error && data) return { kind: 'published', version: (data as { version: number | string }).version };
      if (status === 409 || status === 412) return { kind: 'conflict', status };
      if (status === 503) return { kind: 'unaudited', version: (error as { version?: number | string })?.version };
      return { kind: 'rejected', status, reason: (error as { reason?: string })?.reason };
    } catch {
      return { kind: 'unreachable' };
    }
  };
}
